// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file media/v1/media.proto (package media.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum media.v1.MediaType
 */
export const MediaType = /*@__PURE__*/ proto3.makeEnum(
  "media.v1.MediaType",
  [
    {no: 0, name: "MEDIA_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "MEDIA_TYPE_IMAGE", localName: "IMAGE"},
    {no: 2, name: "MEDIA_TYPE_FILE", localName: "FILE"},
  ],
);

/**
 * @generated from enum media.v1.EntityType
 */
export const EntityType = /*@__PURE__*/ proto3.makeEnum(
  "media.v1.EntityType",
  [
    {no: 0, name: "ENTITY_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "ENTITY_TYPE_PROJECT", localName: "PROJECT"},
    {no: 2, name: "ENTITY_TYPE_TASK", localName: "TASK"},
    {no: 3, name: "ENTITY_TYPE_TASK_LOG", localName: "TASK_LOG"},
    {no: 4, name: "ENTITY_TYPE_TASK_REMARK", localName: "TASK_REMARK"},
    {no: 5, name: "ENTITY_TYPE_USER", localName: "USER"},
    {no: 6, name: "ENTITY_TYPE_TMP", localName: "TMP"},
  ],
);

/**
 * @generated from message media.v1.Media
 */
export const Media = /*@__PURE__*/ proto3.makeMessageType(
  "media.v1.Media",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "original_file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "file_size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(MediaType) },
    { no: 8, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

